import { VIDEOCATEGORY_FETCH_DATA_SUCCESS, VIDEOCATEGORY_HAVE_ERROR, VIDEOCATEGORY_ARE_LOADING } from '../actionType';
import HttpService from '../../utils/httpService';
import { Get } from '../../services/api.service'

export function VideoCategoryAction(action, payload) {
    switch (action) {
        case VIDEOCATEGORY_HAVE_ERROR:
            return {
                type: action,
                hasError: payload
            };

        case VIDEOCATEGORY_ARE_LOADING:
            return {
                type: action,
                isLoading: payload
            };

        case VIDEOCATEGORY_FETCH_DATA_SUCCESS:
            return {
                type: action,
                VideoCategory: payload,
            };

        default:
            return;
    }
}

export function videoCategoryFetchData(data, config) {
    return (dispatch) => {
        try {
            return new Promise((resolve, reject) => {
                dispatch(VideoCategoryAction(VIDEOCATEGORY_ARE_LOADING, true));
                Get(HttpService.videoCategory + data, config).then((result) => {
                    dispatch(VideoCategoryAction(VIDEOCATEGORY_FETCH_DATA_SUCCESS, result));
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
            });
        } catch (error) {
            dispatch(VideoCategoryAction(VIDEOCATEGORY_HAVE_ERROR, true));
        }
    }
}
